/** Shared file-type badge helpers — the small PDF/DOCX chip used by the document
 *  sidebar (BrowserItemList), the documents finder and the case document browser. */

/** Uppercased file extension from a filename, or '' when there isn't one. */
export function fileExt(filename: string | null | undefined): string {
  if (!filename) return ''
  const parts = filename.split('.')
  return parts.length > 1 ? parts.pop()!.toUpperCase() : ''
}

/** Tailwind classes tinting the extension badge (PDF red, DOCX blue, else muted). */
export function extBadgeClass(ext: string): string {
  if (ext === 'PDF') return 'bg-destructive/15 text-destructive'
  if (ext === 'DOCX') return 'bg-info/15 text-info'
  return 'bg-muted text-muted-foreground'
}
